export const APP_INSIGHTS_REMOTE_SERVICE = {
  // [RS] = Remote Service
  GET_SUMMARY: `[RS] GET SUMMARY`,
  GET_SUMMARY_SUCCESS: `[RS] GET SUMMARY SUCCESS`,
  GET_SUMMARY_ERROR: `[RS] GET SUMMARY ERROR`,

  GET_DIAGNOSIS: `[RS] GET DIAGNOSIS`,
  GET_DIAGNOSIS_SUCCESS: `[RS] GET DIAGNOSIS SUCCESS`,
  GET_DIAGNOSIS_ERROR: `[RS] GET DIAGNOSIS ERROR`,

  GET_FEATURES: `[RS] GET FEATURES`,
  GET_FEATURES_SUCCESS: `[RS] GET FEATURES SUCCESS`,
  GET_FEATURES_ERROR: `[RS] GET FEATURES ERROR`,

  SAVE_THRESHOLD: '[RS] SAVE THRESHOLD',
  SAVE_THRESHOLD_SUCCESS: '[RS] SAVE THRESHOLD SUCCESS',
  SAVE_THRESHOLD_ERROR: '[RS] SAVE THRESHOLD ERROR',

  CREATE_ANNUAL_REPORT: '[RS] CREATE ANNUAL REPORT',
  CREATE_ANNUAL_REPORT_SUCCESS: '[RS] CREATE ANNUAL REPORT SUCCESS',
  CREATE_ANNUAL_REPORT_ERROR: '[RS] CREATE ANNUAL REPORT ERROR',
};
